import compose from 'recompose/compose';
import withPropsOnChange from 'recompose/withPropsOnChange';

import withBarberFilterHandlers from '../../../common/filters/withBarberFilterHandlers';
import BarbersFilter from './barbersFilter';
import {
  addBarberFilter,
  removeBarberFilter,
  showAllBarberFilters,
  hideAllBarberFilters,
} from '../actions';
import {
  getActiveBarbersFilterIds,
  getAllBarbersFilter,
} from '../appointmentSelector';

const mapDispatchToProps = {
  add: addBarberFilter,
  remove: removeBarberFilter,
  showAll: showAllBarberFilters,
  hideAll: hideAllBarberFilters,
};

export default compose(
  withBarberFilterHandlers(getActiveBarbersFilterIds, getAllBarbersFilter, mapDispatchToProps),
  withPropsOnChange(
    (props, nextProps) => {
      if (props.currentView !== nextProps.currentView) return true;
      return false;
    },
    (props) => {
      if (props.currentView === 'sideBySide' && props.barbersViewed.length === 0 && props.barbers.length) {
        props.showAll();
        return;
      }
    },
  ),
)(BarbersFilter);
